export const TICKETS_LIST_TAG = { type: "SupportTickets", id: "LIST" } as const;

export const ticketTag = (id: number) =>
  ({ type: "SupportTickets", id }) as const;
